module.exports = __webpack_public_path__ + "img/grid-dots-outer.b836699b.svg";